import { createFormHook, createFormHookContexts, formOptions } from "@tanstack/react-form";
import CommentSection from "../questionComponents/CommentSection";
import RatingAnswerOptions from "../questionComponents/RatingAnswerOptions";
import TextAnswerInput from "../questionComponents/TextAnswerInput";
import MultipleChoiceAnswerOptions from "../questionComponents/MultipleChoiceAnswerOptions";
import type { Answer } from "@pulse/api/surveyApi";

export const { fieldContext, formContext, useFieldContext, useFormContext } =
    createFormHookContexts();

export const { useAppForm, withForm } = createFormHook({
    fieldContext,
    formContext,
    fieldComponents: {
        RatingAnswerOptions,
        CommentSection,
        TextAnswerInput,
        MultipleChoiceAnswerOptions,
    },
    formComponents: {},
});

export const surveyForm = formOptions({
    defaultValues: {
        answers: [] as Answer[],
    },
});
